import { it as reactIt } from '@ews/react-translations';

const it = {
    ...reactIt
};
export default it;
